import React, { Component } from 'react';

import { Loading, SERVER_ERROR } from 'commons';
import request from '../request';

import styles from './Authorize.module.css';

class Authorize extends Component {
  state = {
    error: '',
    loading: true,
    client_name: '',
    client_img_uri: '',
    user_approval_req: ''
  };

  async componentDidMount() {
    const { search } = this.props.location;
    const args = search.slice(search.indexOf('?') + 1).split('&');

    try {
      const res = await request('/api/oauth/authorize', args.join('&'));



      if (res.status >= 400 && res.status < 500) {
        this.setState({
          loading: false,
          error: 'Invalid authoritzation request. Some parameters may be incorrect.'
        });
        return;
      }

      const data = await res.json();

      if (data.error) {
        this.setState({ loading: false, ...SERVER_ERROR });
      } else if (data.redirectUri) {
        document.location.href = data.redirectUri;
      } else {
        // Update request id and next action
        this.setState({ loading: false });
        this.setState({
          user_approval_req: data.user_approval_req,
          client_name: data.client_name,
          client_img_uri: data.client_img_uri
        });
      }
    } catch (error) {
      this.setState({ loading: false, ...SERVER_ERROR });
    }
  }

  renderForm() {
    const { client_img_uri, client_name, user_approval_req, loading, error } = this.state;

    if (loading) return <Loading />;
    if (error.length > 0) return <div className="margin-top-large">{error}</div>;

    return (
      <div>
        <div>
          <img className={styles.apiClientImg} src={client_img_uri} alt="" />
        </div>

        <div className="margin-top-large">
          <strong>{client_name}</strong> wants to access your resources
        </div>

        <div className="margin-top-large">
          <form target="_self" method="post" action={`/api/oauth/approval${this.props.location.search}`}>
            <input type="hidden" name="user_approval_req" value={user_approval_req} />
            <div>
              <button className="btn" name="user_approval" value="false">
                DENY
              </button>
              <button className="btn" name="user_approval" value="true">
                ALLOW
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  render() {
    return <div className="boxed-container">{this.renderForm()}</div>;
  }
}

export default Authorize;
